const ENV_GA4_ID = String(process.env.REACT_APP_GA4_ID || '').trim();

let activeGaId = '';

const resolveGaId = (settingsGaId) => {
  const fromSettings = String(settingsGaId || '').trim();
  if (fromSettings) return fromSettings;
  return ENV_GA4_ID;
};

const isValidGaId = (value) => /^G-[A-Z0-9]+$/i.test(String(value || '').trim());

const bootGaScript = (gaId) => {
  if (typeof document === 'undefined' || !isValidGaId(gaId)) {
    return false;
  }

  if (typeof window.__kayicomBootGa === 'function') {
    window.__kayicomBootGa(gaId);
  }

  if (!document.querySelector(`script[data-kayicom-ga4="${gaId}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
    script.setAttribute('data-kayicom-ga4', gaId);
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = (...args) => {
      window.dataLayer.push(args);
    };
  }

  window.gtag('js', new Date());
  window.gtag('config', gaId, { send_page_view: false });
  activeGaId = gaId;
  return true;
};

export const initSiteAnalytics = (settingsGaId) => {
  if (typeof document === 'undefined') return false;

  const gaId = resolveGaId(settingsGaId);
  if (!isValidGaId(gaId)) {
    return false;
  }

  if (activeGaId === gaId && document.querySelector(`script[data-kayicom-ga4="${gaId}"]`)) {
    return true;
  }

  return bootGaScript(gaId);
};

export const trackPageView = (path, settingsGaId) => {
  const ready = initSiteAnalytics(settingsGaId);
  if (!ready || typeof window === 'undefined' || typeof window.gtag !== 'function' || !activeGaId) {
    return;
  }

  const pagePath = path || window.location.pathname + window.location.search;
  window.gtag('config', activeGaId, {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: document.title,
  });
};

export const applyGoogleSiteVerification = (verificationCode) => {
  if (typeof document === 'undefined') return;
  const content = parseGoogleSiteVerification(verificationCode);
  if (!content) return;

  let meta = document.querySelector('meta[name="google-site-verification"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'google-site-verification');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
};

const GSC_CODE_RE = /^[A-Za-z0-9_-]{10,128}$/;
const GSC_INVALID_HINTS = ['<', '>', 'meta', 'device-width', 'viewport', 'content=', 'kayicom', 'og:'];

export const parseGoogleSiteVerification = (input) => {
  let raw = String(input || '').trim();
  if (!raw) return '';

  if (/google-site-verification/i.test(raw) || raw.toLowerCase().startsWith('<meta')) {
    const match = raw.match(
      /name=["']google-site-verification["'][^>]*content=["']([^"']+)["']/i
    ) || raw.match(
      /content=["']([^"']+)["'][^>]*name=["']google-site-verification["']/i
    );
    raw = match ? match[1].trim() : '';
  }

  if (!raw) return '';
  const lowered = raw.toLowerCase();
  if (GSC_INVALID_HINTS.some((hint) => lowered.includes(hint))) return '';
  return GSC_CODE_RE.test(raw) ? raw : '';
};
